import * as React from 'react';
import styled from 'styled-components';
import FieldDecorator from './FieldDecorator';
import Input, { InputProps } from './Input';
import './fieldStyles.less';

const RangeField = (props: Props) => {
	const { onValueChange, htmlFor, errorMessage, label, value, ...rest } = props;
	const [errorMessageState, setErrorMessageState] = React.useState('');

	const handleChange = (name: string, newValue: number, updatedErrorMessage: string) => {
		// This is so that the onMount validation won't display an error message.
		if (props.value !== newValue) {
			setErrorMessageState(updatedErrorMessage);
		}
		onValueChange(name, newValue, updatedErrorMessage);
	};

	let valueToSet = value;
	if (!props.value && props.min !== props.value) valueToSet = props.min;

	return (
		<FieldDecorator
			label={label}
			className={`range${props.className ? ` ${props.className}` : ''}`}
			errorMessage={errorMessage || errorMessageState}
			htmlFor={htmlFor}
		>
			{/* TODO Revise UX to support not required. */}
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<Input type="range" {...rest} required value={valueToSet} onValueChange={handleChange} />
			<span className="min">{props.min}</span>
			<span className="max">{props.max}</span>
			<Value>{valueToSet}</Value>
		</FieldDecorator>
	);
};

interface Props extends InputProps {
	max: number;
	min: number;
	value: number;
	htmlFor?: string;
	errorMessage?: string;
	patternErrorMessage?: string;
}

RangeField.defaultProps = {
	htmlFor: null,
	errorMessage: null,
	patternErrorMessage: null
};

export default RangeField;

const Value = styled.span`
	display: flex;
	justify-content: center;
`;
